import { render } from "./VariableInsertElement.vue?vue&type=template&id=10b120ad&scoped=true"
import script from "./VariableInsertElement.vue?vue&type=script&lang=js"
export * from "./VariableInsertElement.vue?vue&type=script&lang=js"

import "./VariableInsertElement.vue?vue&type=style&index=0&id=10b120ad&scoped=true&lang=css"

import exportComponent from "../../../../peelochat-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10b120ad"]])

export default __exports__